import Head from './head';

export default Head;
